import React, {useState,  useEffect } from 'react';
import DeckGL, { _GlobeView } from 'deck.gl';
import {
    LightingEffect,
    AmbientLight,
} from "@deck.gl/core";

import { CSVLoader } from '@loaders.gl/csv';

import zipLoader from './zipLoader'


import { renderLayers } from "./RenderLayers";

// 初期ビューポートの設定
const INITIAL_VIEW_STATE = {
    latitude: 38.17235759245721,
    longitude: 136.85153168318723,
    bearing: 0,
    pitch: 0,
    zoom: 1
};

const views = [new _GlobeView({
    resolution: 100
})]

const ambientLight = new AmbientLight({
    color: [255, 255, 255],
    intensity:5
});


 
function Map() {
    const [data, setData] = useState(null)
    const [viwState, setViewState] = useState(INITIAL_VIEW_STATE)
    const [effects] = useState(() => {
        const lightingEffect = new LightingEffect({ ambientLight });
        lightingEffect.shadowColor = [0, 0, 0, 0.5];
        return [lightingEffect];
    });


    useEffect(() => {
        const loadData = async (url) => {
            const res = await zipLoader(url, CSVLoader, (d) => {
                //console.log(d) //ローディング処理
            })
            setData(res)
        }

        loadData("./data/world_pop.zip")

    }, [])


    return (
        <div>
            <DeckGL
                views={views}
                effects={effects}
                initialViewState={viwState}
                controller={{ inertia: true }}
                layers={renderLayers({ data })}
                //onViewStateChange={(v)=>console.log(v.viewState)}
            >
            </DeckGL>
            <div id="fieldset">
                <legend>Areas with high population density</legend>
            </div>
            
            <div className="attribution">
                source：<a
                    href="https://developers.google.com/earth-engine/datasets/catalog/WorldPop_GP_100m_pop"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    WorldPop 
                </a>
            </div>
        </div>
    );
}

export default Map;